import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function TeamsFeatureGate(props: Props) {
    return (
        <FeatureGateModalWrapper
            title='Use teams to organize your CRM'
            description='Organize your users into teams for assignment, quotas, and more'
            bullets={[
                'Report on efforts and outcomes per team',
                'Use round-robin assignment to distribute leads to your team',
                'Set sales & activity quotas on a per-team basis',
            ]}
            feature='teams'
            isOpen={props.isOpen}
            onClose={props.onClose}
        />
    );
}
